import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { first } from 'rxjs/operators';

import { GTMService } from '@services';
import { AnalyticsStore, EnergyHistoricalDataStore, FeatureService } from '@store';

import { DropdownSelectOption } from './../../../../shared/components/dropdown-select/dropdown-select.component';
import { FilterType } from './energy-filters.data';

import Moment = moment.Moment;

@Component({
  selector: 'app-energy-filters-header',
  templateUrl: './energy-filters-header.component.html',
  styleUrls: ['./energy-filters-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnergyFiltersHeaderComponent implements OnInit {
  @Input() isThermalFlow: boolean;

  FilterType = FilterType;
  parametersPopupVisible = false;

  constructor(
    public featureService: FeatureService,
    private energyHistoricalDataStore: EnergyHistoricalDataStore,
    private translateService: TranslateService,
    private gtmService: GTMService,
    protected analyticsStore: AnalyticsStore
  ) {}

  filters: DropdownSelectOption[] = [
    {
      value: FilterType.Day,
      viewValue: this.translateService.instant('+ENERGY_HISTORY.FILTER.DAY'),
    },
    {
      value: FilterType.Month,
      viewValue: this.translateService.instant('+ENERGY_HISTORY.FILTER.MONTH'),
    },
    {
      value: FilterType.Year,
      viewValue: this.translateService.instant('+ENERGY_HISTORY.FILTER.YEAR'),
    },
    {
      value: FilterType.Total,
      viewValue: this.translateService.instant('+ENERGY_HISTORY.FILTER.TOTAL'),
    },
  ];

  defaultFilter: DropdownSelectOption;
  activeFilter: FilterType;

  filterOptions: { value: string; viewValue: string }[];

  private selectedDate: Moment = moment(new Date());

  ngOnInit(): void {
    this.setDefaultFilter();
  }

  changeFilter(selectedFilter: { value: FilterType }): void {
    this.activeFilter = selectedFilter.value;
    this.selectedDate = moment(new Date());

    this.energyHistoricalDataStore.setFilterType(this.getActiveFilter(), this.selectedDate);
    this.gtmService.track('onSet', 'Filter Type', 'Hems');
  }

  changeDate(date: Moment): void {
    this.selectedDate = date;
    this.energyHistoricalDataStore.setFilterType(this.getActiveFilter(), this.selectedDate);
    this.gtmService.track('onChange', 'Date', 'Hems');
  }

  getActiveFilter(): FilterType {
    return this.activeFilter;
  }

  toggleParametersPopup(): void {
    this.parametersPopupVisible = !this.parametersPopupVisible;
  }

  private setDefaultFilter(): void {
    this.energyHistoricalDataStore.filterType$.pipe(first()).subscribe((filterType: FilterType) => {
      const foundFilter = this.filters.find((entry) => entry.value === filterType);
      this.defaultFilter = foundFilter;
      this.activeFilter = foundFilter.value;
    });
  }
}
